import React from 'react';
import { Link } from 'react-router-dom';
import { FaGithub, FaLinkedin, FaEnvelope, FaTwitter, FaInstagram, FaYoutube } from 'react-icons/fa';
import { IconType } from 'react-icons';

interface SocialLink {
  icon: IconType;
  url: string;
  label: string;
}

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();
  const socialLinks: SocialLink[] = [
    { icon: FaGithub, url: 'https://github.com/adarsh-chaunal', label: 'GitHub' },
    { icon: FaLinkedin, url: 'https://www.linkedin.com/in/adarsh-chaunal-016974157/', label: 'LinkedIn' },
    { icon: FaInstagram, url: 'https://www.instagram.com/adarsh_chaunal/', label: 'Instagram' },
    { icon: FaYoutube, url: 'https://www.youtube.com/@adarshchaunal', label: 'YouTube' },
    { icon: FaTwitter, url: 'https://x.com/adarshchaunal', label: 'X (Twitter)' },
    { icon: FaEnvelope, url: 'mailto:chaunal.adarsh@gmail.com', label: 'Email' },
  ];

  return (
    <footer className="bg-gray-900 dark:bg-gray-950 text-white py-12">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div>
            <h3 className="text-2xl font-bold mb-4">Adarsh Chaunal</h3>
            <p className="text-gray-400">
              .NET Developer specializing in modern web technologies, cloud infrastructure, and AI solutions.
            </p>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-gray-400 hover:text-white transition-colors">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-gray-400 hover:text-white transition-colors">
                  About
                </Link>
              </li>
              <li>
                <Link to="/projects" className="text-gray-400 hover:text-white transition-colors">
                  Projects
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-400 hover:text-white transition-colors">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4">Connect</h4>
            <div className="flex space-x-4">
              {socialLinks.map(({ icon: Icon, url, label }) => (
                <a
                  key={label}
                  href={url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-400 hover:text-white transition-colors"
                  aria-label={label}
                >
                  <Icon size={24} />
                </a>
              ))}
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 text-center text-gray-400">
          <p>&copy; {currentYear} Adarsh Chaunal. All rights reserved.</p>
          <p className="mt-2">
            <a href="https://adarshchaunal.com" className="hover:text-white transition-colors">
              adarshchaunal.com
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
